export const widgetTitleDefaultSettings = {
  widgetTitle: false,
  widgetTitleTitle: '',
  widgetTitleCaption: '',
  widgetTitleTitleColor: 'rgb(17, 17, 17)',
  widgetTitleCaptionColor: 'rgb(17, 17, 17)',
  widgetTitleLinksColor: 'rgb(25, 123, 255)',
  widgetTitleAlignment: 'center',
  enabledTextBalance: true,
  widgetTitleTitleTextStyle: {
    fontSize: 24,
    fontWeight: 'bold',
    fontStyle: 'normal'
  },
  widgetTitleCaptionTextStyle: {
    fontSize: 16
  }
} as const;
